/* constant/production.js */

import baseConstant from './development'
let constant = baseConstant

// 僅調整與 dev 有差別的部分就好
//constant = { ...constant, apiUrl: 'http://issbg.efoxconn.com/service' }

switch(process.env.MODE) {
  case 'test':
    constant = Object.assign({}, constant, {apiUrl: 'http://192.168.168.152'});
  break;
  case 'sqa':
    constant = Object.assign({}, constant, {apiUrl: 'http://192.168.23.66'});
  break;
  case 'aws':
    constant = Object.assign({}, constant, {apiUrl: 'https://elearning.issbg.site'});
  break;
  case 'prod':
    constant = Object.assign({}, constant, {apiUrl: 'http://issbg.efoxconn.com/service'});
  break;
  case 'alpha':
    // constant = Object.assign({}, constant, {apiUrl: 'http://35.74.72.151'});
    constant = Object.assign({}, constant, {apiUrl: 'https://elearningtest.issbg.site'});
  break;
}

export default constant



// WEBPACK FOOTER //
// ./src/constant/production.js